'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Suspense } from 'react';
import SignOutButton from '@/app/_components/SignOutButton';
import { useCustomer } from '@/app/_lib/hooks';
const PageNav = t0 => {
  const $ = _c(56);
  const {
    pageKey
  } = t0;
  const {
    customer
  } = useCustomer();
  let t1;
  if ($[0] !== customer || $[1] !== pageKey) {
    t1 = customer && <div className="lg:hidden flex gap-4 overflow-x-auto pb-2 -mx-4 px-4"><Link aria-current={pageKey == "dashboard" ? "page" : undefined} href="/account" className={`text-xs font-medium whitespace-nowrap transition-colors ${pageKey == "dashboard" ? "text-primary" : "text-dark hover:text-primary"}`}>Your Account</Link><Link aria-current={pageKey == "order_history" ? "page" : undefined} href="/account/order-history" className={`text-xs font-medium whitespace-nowrap transition-colors ${pageKey == "order_history" ? "text-primary" : "text-dark hover:text-primary"}`}>Orders</Link><SignOutButton className="text-xs font-medium whitespace-nowrap transition-colors text-dark hover:text-primary ml-auto">Sign Out</SignOutButton></div>;
    $[0] = customer;
    $[1] = pageKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Suspense>{t1}</Suspense>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== customer || $[6] !== pageKey) {
    t3 = customer && <div className="mb-6"><div className="mb-10"><div className="font-medium text-xs">{customer.billing_first_name} {customer.billing_last_name}</div><SignOutButton className="text-xs underline text-nowrap">Sign Out</SignOutButton></div><Link aria-current={pageKey == "dashboard" ? "page" : undefined} className={`text-nowrap font-medium text-xs block mb-3 transition-colors ${pageKey == "dashboard" ? "text-primary" : ""}`} href="/account">Your Account</Link><Link aria-current={pageKey == "order_history" ? "page" : undefined} className={`block mb-1 text-xs transition-colors ${pageKey == "order_history" ? "text-primary" : "text-light"}`} href="/account/order-history">Order History</Link></div>;
    $[5] = customer;
    $[6] = pageKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <Suspense>{t3}</Suspense>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="text-sm font-medium mb-3 pb-2 border-b-1 border-gray-8">Support</div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = pageKey == "about" ? "page" : undefined;
  const t7 = `block mb-1 text-xs transition-colors ${pageKey == "about" ? "text-primary" : "text-light"}`;
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <Link aria-current={t6} className={t7} href="/about-hive">About hive</Link>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = pageKey == "sales_assistance" ? "page" : undefined;
  const t10 = `block mb-1 text-xs transition-colors ${pageKey == "sales_assistance" ? "text-primary" : "text-light"}`;
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <Link aria-current={t9} className={t10} href="/hive-sales-assistance">Sales Assistance</Link>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = pageKey == "trade_program" ? "page" : undefined;
  const t13 = `block mb-1 text-xs transition-colors ${pageKey == "trade_program" ? "text-primary" : "text-light"}`;
  let t14;
  if ($[17] !== t12 || $[18] !== t13) {
    t14 = <Link aria-current={t12} className={t13} href="/hive-trade-program">Trade Program</Link>;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = pageKey == "samples" ? "page" : undefined;
  const t16 = `block mb-1 text-xs transition-colors ${pageKey == "samples" ? "text-primary" : "text-light"}`;
  let t17;
  if ($[20] !== t15 || $[21] !== t16) {
    t17 = <Link aria-current={t15} className={t16} href="/hive-samples">Swatch Samples</Link>;
    $[20] = t15;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  const t18 = pageKey == "order_status" ? "page" : undefined;
  const t19 = `block mb-1 text-xs transition-colors ${pageKey == "order_status" ? "text-primary" : "text-light"}`;
  let t20;
  if ($[23] !== t18 || $[24] !== t19) {
    t20 = <Link aria-current={t18} className={t19} href="/hive-order-status">Order Status</Link>;
    $[23] = t18;
    $[24] = t19;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  const t21 = pageKey == "contact" ? "page" : undefined;
  const t22 = `block mb-1 text-xs transition-colors ${pageKey == "contact" ? "text-primary" : "text-light"}`;
  let t23;
  if ($[26] !== t21 || $[27] !== t22) {
    t23 = <Link aria-current={t21} className={t22} href="/contact-hive">Contact</Link>;
    $[26] = t21;
    $[27] = t22;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  const t24 = pageKey == "faq" ? "page" : undefined;
  const t25 = `block mb-1 text-xs transition-colors ${pageKey == "faq" ? "text-primary" : "text-light"}`;
  let t26;
  if ($[29] !== t24 || $[30] !== t25) {
    t26 = <Link aria-current={t24} className={t25} href="/hive-modern-frequently-asked-questions">FAQ</Link>;
    $[29] = t24;
    $[30] = t25;
    $[31] = t26;
  } else {
    t26 = $[31];
  }
  const t27 = pageKey == "store_policy" ? "page" : undefined;
  const t28 = `block mb-1 text-xs transition-colors ${pageKey == "store_policy" ? "text-primary" : "text-light"}`;
  let t29;
  if ($[32] !== t27 || $[33] !== t28) {
    t29 = <Link aria-current={t27} className={t28} href="/hive-modern-store-policy">Policies</Link>;
    $[32] = t27;
    $[33] = t28;
    $[34] = t29;
  } else {
    t29 = $[34];
  }
  const t30 = pageKey == "privacy_policy" ? "page" : undefined;
  const t31 = `block mb-1 text-xs transition-colors ${pageKey == "privacy_policy" ? "text-primary" : "text-light"}`;
  let t32;
  if ($[35] !== t30 || $[36] !== t31) {
    t32 = <Link aria-current={t30} className={t31} href="/hive-modern-privacy-policy">Privacy</Link>;
    $[35] = t30;
    $[36] = t31;
    $[37] = t32;
  } else {
    t32 = $[37];
  }
  const t33 = pageKey == "cookies_policy" ? "page" : undefined;
  const t34 = `block mb-8 text-xs transition-colors ${pageKey == "cookies_policy" ? "text-primary" : "text-light"}`;
  let t35;
  if ($[38] !== t33 || $[39] !== t34) {
    t35 = <Link aria-current={t33} className={t34} href="/hive-modern-cookies-policy">Cookie Policy</Link>;
    $[38] = t33;
    $[39] = t34;
    $[40] = t35;
  } else {
    t35 = $[40];
  }
  let t36;
  if ($[41] !== t11 || $[42] !== t14 || $[43] !== t17 || $[44] !== t20 || $[45] !== t23 || $[46] !== t26 || $[47] !== t29 || $[48] !== t32 || $[49] !== t35 || $[50] !== t4 || $[51] !== t8) {
    t36 = <div className="hidden lg:block">{t4}{t5}{t8}{t11}{t14}{t17}{t20}{t23}{t26}{t29}{t32}{t35}</div>;
    $[41] = t11;
    $[42] = t14;
    $[43] = t17;
    $[44] = t20;
    $[45] = t23;
    $[46] = t26;
    $[47] = t29;
    $[48] = t32;
    $[49] = t35;
    $[50] = t4;
    $[51] = t8;
    $[52] = t36;
  } else {
    t36 = $[52];
  }
  let t37;
  if ($[53] !== t2 || $[54] !== t36) {
    t37 = <><div className="w-full mb-6 lg:mb-0 lg:relative lg:w-[clamp(250px,22vw,345px)] lg:mr-8 flex flex-col items-start shrink-0"><nav className="w-full h-full relative" aria-label="Account">{t2}{t36}</nav></div></>;
    $[53] = t2;
    $[54] = t36;
    $[55] = t37;
  } else {
    t37 = $[55];
  }
  return t37;
};
export default PageNav;

/*
<div className="hidden lg:block min-w-32 mr-8 mb-12 lg:min-w-[175px]">
    <div className="mb-10 lg:mb-12">
        <div className="font-medium text-xs">{customer.billing_first_name} {customer.billing_last_name}</div>
        <SignOutButton className="text-xs underline text-nowrap">Sign Out</SignOutButton>
    </div>
    <Link aria-current={pageKey == 'dashboard' ? 'page' : undefined} className={` text-nowrap font-medium text-xs block mb-3 ${(pageKey == 'dashboard') ? 'text-primary' : ''}`} href="/account">My Dashboard</Link>
    <ul className="">
        <li><Link aria-current={pageKey == 'order_history' ? 'page' : undefined} className={`block mb-1 text-xs text-light ${(pageKey == 'order_history') ? 'text-primary' : ''}`} href="/account/order-history">Order History</Link></li>
        <li><Link aria-current={pageKey == 'favorites' ? 'page' : undefined} className={`block mb-1 text-xs text-light ${(pageKey == 'favorites') ? 'text-primary' : ''}`} href="/favorites">Favorites</Link></li>
        <li><Link aria-current={pageKey == 'address_book' ? 'page' : undefined} className={`block mb-1 text-xs text-light ${(pageKey == 'address_book') ? 'text-primary' : ''}`} href="/account/address-book">Address Book</Link></li>
        <li><Link aria-current={pageKey == 'settings' ? 'page' : undefined} className={`block mb-1 text-xs text-light ${(pageKey == 'settings') ? 'text-primary' : ''}`} href="/account/settings">Settings</Link></li>
    </ul>
    
    <div className="font-medium text-xs mb-3 mt-6">Help</div>
    <Link className="block mb-1 text-xs text-light" href="/account/order-history">FAQ</Link>
    <Link className="block mb-1 text-xs text-light" href="/favorites">Policies</Link>
    <Link className="block mb-1 text-xs text-light" href="/account/preferences">Contact Us</Link>
</div>
*/